const getURL = (location.pathname).indexOf('default.aspx');
const baseUrl = SITEBASEURL + 'p/tickets';

if (getURL >= 0 || location.pathname == '/') {
  window.location = baseUrl;
}

function modifyFeatureLineup() {
  function lineupButtonsGrid(lineup) {
    const containerSize = lineup.width();
    const buttonContainer = lineup.find('.featureLineup-buttons.subContainer');
    const icons = buttonContainer.find('.featureLineup-social');
    const buttons = buttonContainer.find('.featureLineup-buynow');

    // if icons length + buttons length is greater than containerSize then add class "grid" to buttonContainer

    if (icons.width() + buttons.width() > containerSize) {
      buttonContainer.addClass('column');
    }

    // remove icons if there 0 children
    if (!icons.children().length) {
      icons.remove();
    }
  }

  $('.featureLineupContainer').each((i, element) => {
    const $element = $(element);

    lineupButtonsGrid($element);
  });
}

$(document).ready(function () {
  $('.generalmessage').prependTo('header');
  $('.header-logo').attr({href: "https://hiltonheadrhythmandbrews.com/", target: "_blank"});  
  modifyFeatureLineup();
});
